/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { User } from '../../models/user';

export interface ApiUsersUserCompanyCodeGet$Plain$Params {
  userCompanyCode: string;
}

export function apiUsersUserCompanyCodeGet$Plain(http: HttpClient, rootUrl: string, params: ApiUsersUserCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<User>>> {
  const rb = new RequestBuilder(rootUrl, apiUsersUserCompanyCodeGet$Plain.PATH, 'get');
  if (params) {
    rb.path('userCompanyCode', params.userCompanyCode, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<User>>;
    })
  );
}

apiUsersUserCompanyCodeGet$Plain.PATH = '/api/Users/{userCompanyCode}';
